import React from 'react'
import '../Styles/PageDesc.css'
import { Link } from 'react-router-dom'

const PageDesc = ({title, content, btnText}) => {
  // Function to open Google Maps with the location
  const openGoogleMaps = () => {
    // Coordinates for Rajapushpa Summit, Financial District, Hyderabad
    const latitude = 17.4143; // Approximate coordinates for Rajapushpa Summit
    const longitude = 78.3480; // Approximate coordinates for Rajapushpa Summit
    const locationName = "GET PLACED INDIA PRIVATE LIMITED, Rajapushpa Summit, Financial District, Hyderabad";
    
    // Create Google Maps URL
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(locationName)}`;
    
    // Open Google Maps in a new tab
    window.open(googleMapsUrl, '_blank');
  };

  return (
    <div className='desc-main-block'>
      <h1 className='desc-heading'>{title}</h1>
      <p className='desc-content'>{content}</p>
      
      {/* Conditionally render button based on button text */}
      {btnText && btnText.length > 0 && (
        btnText === "Get Directions" ? (
          // For "Get Directions" button, use the Google Maps function
          <button className='desc-button' onClick={openGoogleMaps}>
            {btnText}
          </button>
        ) : (
          // For other buttons, use the original Link
          <Link to='/enroll-now' className='link'>
            <button className='desc-button'>{btnText}</button>
          </Link>
        )
      )}
    </div>
  )
}

export default PageDesc